import { render, staticRenderFns } from "./terms-component.vue?vue&type=template&id=9bc16d40&"
import script from "./terms-component.vue?vue&type=script&lang=ts&"
export * from "./terms-component.vue?vue&type=script&lang=ts&"
import style0 from "./terms-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports